import axios from '@/services/axios-auth-wrapper';
import { dateHelperService } from '@/services/date-helper-service';

const url = process.env.VUE_APP_CONVERSABILITY_API_URL + '/api/metric/';

class MetricService {
    getAvailableMetricDateRangeForProject (id) {
        return axios.get(`${url}${id}/dates`);
    }
    getMetricsForDateRange (projectId, startDate, endDate) {
        let apiStartDate = dateHelperService.formatForAPI(startDate);
        let apiEndDate = dateHelperService.formatForAPI(endDate);
        return axios.get(`${url}${projectId}?startDate=${apiStartDate}&endDate=${apiEndDate}`);
    }
};

export const metricService = new MetricService();
